// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__EGq_i","layoutFixed":"layout_layoutFixed__uiAsP"};